/**
 * environment variables used in the application
 */
export enum EnvironmentVariable {
  REACT_APP_FIREBASE_API_KEY = 'REACT_APP_FIREBASE_API_KEY',
  REACT_APP_FIREBASE_AUTH_DOMAIN = 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  REACT_APP_FIREBASE_PROJECT_ID = 'REACT_APP_FIREBASE_PROJECT_ID',
  REACT_APP_FIREBASE_STORAGE_BUCKET = 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  REACT_APP_FIREBASE_MESSAGE_SENDER_ID = 'REACT_APP_FIREBASE_MESSAGE_SENDER_ID',
  REACT_APP_FIREBASE_APP_ID = 'REACT_APP_FIREBASE_APP_ID',
  REACT_APP_FIREBASE_MEASUREMENT_ID = 'REACT_APP_FIREBASE_MEASUREMENT_ID',
}
